import { __awaiter, __generator } from "tslib";
import { fetchIdentity } from '@office-start/identity-service';
import { logGenericEvent } from '@office-start/instrumentation-service';
import { logFeature } from '@office-start/telemetry-service';
export var logDimeEvent = function (_a) {
    var eventName = _a.eventName, dimeExperience = _a.dimeExperience, _b = _a.result, result = _b === void 0 ? '' : _b, _c = _a.metaData, metaData = _c === void 0 ? '' : _c, _d = _a.extraInfo, extraInfo = _d === void 0 ? '' : _d;
    return __awaiter(void 0, void 0, void 0, function () {
        var userCountryCode, identity, _e, params, debugInfo;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    userCountryCode = '';
                    _f.label = 1;
                case 1:
                    _f.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, fetchIdentity()];
                case 2:
                    identity = _f.sent();
                    if (identity === null || identity === void 0 ? void 0 : identity.userCountryCode) {
                        userCountryCode = identity === null || identity === void 0 ? void 0 : identity.userCountryCode;
                    }
                    return [3 /*break*/, 4];
                case 3:
                    _e = _f.sent();
                    return [3 /*break*/, 4];
                case 4:
                    params = {};
                    params["DimeExperience" /* InstrumentationParam.DimeExperience */] = dimeExperience;
                    params["State" /* InstrumentationParam.State */] = result;
                    params["UserCountryCode" /* InstrumentationParam.UserCountryCode */] = userCountryCode;
                    debugInfo = extraInfo ? extraInfo + ';' : '';
                    if (typeof metaData === 'string' && metaData) {
                        debugInfo = debugInfo + metaData;
                    }
                    else {
                        try {
                            debugInfo = debugInfo + JSON.stringify(metaData);
                        }
                        catch (_g) {
                            /* Fall through if passed unstringifiable object */
                        }
                    }
                    params["DebugInfo" /* InstrumentationParam.DebugInfo */] = debugInfo;
                    logGenericEvent(eventName, params);
                    logFeature({
                        featureName: "Upsell" /* KnownFeatureNames.Upsell */,
                        eventName: eventName,
                        area: 'Other',
                        params: {
                            DimeExperience: dimeExperience,
                            State: result,
                            DebugInfo: debugInfo,
                            UserCountryCode: userCountryCode,
                        },
                    });
                    return [2 /*return*/];
            }
        });
    });
};
//# sourceMappingURL=telemetry.js.map